import React from "react";
import {
  LandingHeadingContainer,
  IntroductionContainer,
  HeadingRow,
  Column,
  LandingHeadline,
} from "../styles/components/landing";

const Heading = () => {
  return (
    <IntroductionContainer id="introduction">
      <LandingHeadingContainer>
        <HeadingRow>
          <LandingHeadline>Highsnobiety</LandingHeadline>
        </HeadingRow>
        <HeadingRow $justify="space-between">
          <Column>
            <LandingHeadline>Not in</LandingHeadline>
          </Column>
          <Column>
            <LandingHeadline $large>Miami</LandingHeadline>
          </Column>
        </HeadingRow>
        <HeadingRow $justify="flex-end">
          <LandingHeadline>Art week</LandingHeadline>
        </HeadingRow>
      </LandingHeadingContainer>
    </IntroductionContainer>
  );
};

export default Heading;
